import { Box, SingleSelect, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items } from "designSystemLegacy/data";

export default () => {
	return (
		<CssColumnGrid columns={3}>
			<Text semiBold text="normal" />
			<Text semiBold text="overflow with the default tooltip" />
			<Text semiBold text="overflow with placement of tooltip set to right" />
			<SingleSelect
				options={items}
				value={items[0]}
			/>
			<Box width={200}>
				<SingleSelect
					options={items}
					value={items[4]}
				/>
			</Box>
			<Box width={200}>
				<SingleSelect
					options={items}
					tooltipPlacement="right"
					value={items[4]}
				/>
			</Box>
		</CssColumnGrid>
	);
};